import type { BriefTenantPulse } from '../../data/types';
import { cn } from '../../lib/utils';

interface TenantPulseProps {
  tenants: BriefTenantPulse[];
}

const STATUS_DOT: Record<BriefTenantPulse['status'], string> = {
  noisy: 'bg-brand-blue',
  normal: 'bg-neutral-semi-light',
  quiet: 'bg-brand-lime',
};

export function TenantPulse({ tenants }: TenantPulseProps) {
  return (
    <section className="lg:col-span-4 bg-bg-secondary border border-border-default rounded-xl overflow-hidden flex flex-col">
      <header className="flex items-center justify-between px-4 py-3 border-b border-border-light">
        <h3 className="font-sans font-medium text-[12.5px] text-text-primary m-0">Tenant pulse</h3>
        <span className="font-mono text-[10.5px] text-text-secondary px-1.5 py-px bg-bg-tertiary rounded border border-border-default">
          last 14h
        </span>
      </header>
      <div className="flex-1">
        {tenants.length === 0 ? (
          <div className="px-4 py-12 text-center text-text-secondary text-sm">No tenants enabled.</div>
        ) : (
          tenants.map((t, i) => (
            <div
              key={t.tenantId}
              className={cn(
                'flex items-center justify-between px-4 py-2.5',
                i !== tenants.length - 1 && 'border-b border-border-light'
              )}
            >
              <div className="flex items-center gap-2.5 min-w-0">
                <span className={cn('w-2 h-2 rounded-full flex-shrink-0', STATUS_DOT[t.status])} />
                <div className="min-w-0">
                  <div className="font-sans font-medium text-[12.5px] text-text-primary truncate">
                    {t.displayName}
                  </div>
                  {t.reason && (
                    <div className="text-[11px] text-text-secondary mt-0.5 truncate">{t.reason}</div>
                  )}
                </div>
              </div>
              <div className="text-right flex-shrink-0">
                <div className="font-mono text-[14px] font-medium text-text-primary">
                  {t.openCount}
                  <span className="text-text-muted ml-1 text-[12px]">open</span>
                </div>
                <div className="font-mono text-[10.5px] text-text-muted mt-0.5">
                  {t.receivedCount} received
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </section>
  );
}
